import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NotificationBar from '@surfline/quiver-react/dist/NotificationBar';
import Notification from '@surfline/quiver-react/dist/Notification';
import CTA from '@surfline/quiver-react/dist/SurflinePageContainer/CTA';
import cookie from 'react-cookie';
import userPropType from '@surfline/quiver-react/dist/PropTypes/userPropType';

class NotificationBarController extends Component {

  renderBaseNotification = () => {
    const dismissDuration = 1000 * 60 * 60 * 24 * 8;
    const savedTimestamp = cookie.load('dismissTimestamp');
    const nextPresentationTime = savedTimestamp != null ?
      dismissDuration + parseInt(savedTimestamp, 10) : 0;

    const dismissBannerHandler = () => {
      cookie.save('dismissTimestamp', Date.now(), null);
    };

    return nextPresentationTime < Date.now() ? (
      <Notification
        closable
        type="large"
        level="information"
        onCloseComplete={dismissBannerHandler}
      >
        <CTA className="quiver-notification__tag-line" ctaLocation="upsell bar">
          <span className="quiver-notification__tag-line__full-text">
            Ad-free Cams. Expert Forecast Analysis.
          </span> GO PREMIUM.
        </CTA>
      </Notification>
    ) : null;
  };

  renderOpenHouseNotification = () => {
    const {
      user,
      openHouse: {
      data: {
        sponsorName,
        banner: {
          copy,
        },
      },
    } } = this.props;

    const trackSignUpClick = () => window.analytics.track(
      'Clicked Link',
      {
        linkLocation: 'premium open house',
        linkName: 'sign up',
      },
    );

    const trackUpgradeClick = () => window.analytics.track(
      'Clicked Link',
      {
        linkLocation: 'premium open house',
        linkName: 'upgrade',
      },
    );

    return (
      <Notification type="large" level="information">
        <a
          href={user ? '/upgrade' : '/create-account'}
          className="quiver-notification__tag-line"
          onClick={user ? trackUpgradeClick : trackSignUpClick}
        >
          {user
            ? `Premium access provided by ${sponsorName}. Go Premium to keep ad-free cams and 17-day forecasts`
            : `${copy}. Sign Up`}
        </a>
      </Notification>
    );
  };

  renderNotification = () => {
    const { isPremium } = this.props;
    const showOpenHouse = this.props.openHouse.active === true;

    if (isPremium) return null;

    if (showOpenHouse) {
      return this.renderOpenHouseNotification();
    }

    return this.renderBaseNotification();
  }

  render() {
    return (
      <NotificationBar largeNotification={this.renderNotification()} />
    );
  }
}

NotificationBarController.propTypes = {
  isPremium: PropTypes.bool.isRequired,
  user: userPropType,
  openHouse: PropTypes.shape({
    active: PropTypes.bool.isRequired,
    data: PropTypes.shape({
      banner: PropTypes.shape({
        copy: PropTypes.string.isRequired,
        creative: PropTypes.shape({
          '1x': PropTypes.string.isRequired,
          '2x': PropTypes.string,
          '3x': PropTypes.string,
        }).isRequired,
      }),
    }),
  }).isRequired,
};

NotificationBarController.defaultProps = {
  user: null,
};

export default NotificationBarController;



// WEBPACK FOOTER //
// ./src/bundles/margins/NotificationBarController.js